import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconIcebowl: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="icebowl, cooling, vibe"><ellipse cx="12" cy="8.5" rx="10.25" ry="4.25" stroke="currentColor" strokeWidth="1.5"/><path d="M22.25 8.5V9.52273C22.25 15.1711 17.6609 19.75 12 19.75C6.33908 19.75 1.75 15.1711 1.75 9.52273V8.5" stroke="currentColor" strokeWidth="1.5"/><path d="M9.5 8L11.5 7M6 7.5L7 9M12.5 9.25L14.5 9.75M16 7.5L17.5 8.5" stroke="currentColor" strokeWidth="1.75"/></CentralIconBase>;
};

export default IconIcebowl;
